export default function Footer() {
  return (
    <footer class="bg-[#000000] w-full px-8 py-4 text-center text-[#ffffff] sm:text-[20px] text-[12px]">
      ALL RIGHTS RESERVED BY CENTRAL INTELLIGENCE | ANY UNLAWFUL DISTRIBUTION OF
      THIS CONTENT WILL BE ENFORCED VIA CHAPTER 12-03B § 19 OF THE INTERNATIONAL
      CODE
    </footer>
  );
}
